jQuery(document).ready(function ($) {
    const galleries = $('.js-content-with-gallery');

    const sliders = [];

    galleries.each(function () {
        const swiper = new Swiper(`.js-content-with-gallery[data-gallery-id="${$(this).attr('data-gallery-id')}"]`, {
            loop: true,

            slidesPerView: 1,

            autoplay: true,
            delay: 4000,

            grabCursor: true,

            pagination: {
                el: '.content-with-gallery__gallery--pagination',

                bulletClass: 'pagination-bullet',
                bulletActiveClass: 'active',

                clickable: true,
            },

            navigation: {
                prevEl: '.content-with-gallery__gallery--prev',
                nextEl: '.content-with-gallery__gallery--next'
            },

            slideClass: 'content-with-gallery__image'
        });
    });
});